import Timer from './timer';

export default Timer;
